import React from 'react';
import { PaymentRequestButtonElement, ElementsConsumer } from '@stripe/react-stripe-js';
import PropTypes from 'prop-types';

export default class InjectedPaymentRequestButton extends React.Component {
  static propTypes = {
    onSubscribe: PropTypes.func
  }

  render () {
    return (
      <ElementsConsumer>
        {({ stripe }) => (
          <PaymentRequestButton stripe={ stripe } onSubscribe={ this.props.onSubscribe } />
        )}
      </ElementsConsumer>
    );
  }
}

class PaymentRequestButton extends React.Component {
  static propTypes = {
    stripe: PropTypes.object,
    onSubscribe: PropTypes.func
  }

  state = {
    canMakePayment: false,
    hasCheckedAvailability: false,
    errorMessage: null,
    paymentRequest: null
  };

  static styleOptions = {
    style: {
      paymentRequestButton: {
        type: 'default',
        theme: 'dark'
      }
    },
  };

  async componentDidUpdate() {
    if (this.props.stripe && !this.state.paymentRequest) {
      this.wireUpPaymentRequest();
    }
  }

  async wireUpPaymentRequest() {
    const paymentRequest = await this.props.stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: 'Yak Tack Monthly Subscription',
        amount: 200,
      },
    });

    this.setState({ paymentRequest: paymentRequest });

    paymentRequest.on('paymentmethod', async (event) => {
      this.props.onSubscribe(event.paymentMethod.id)
      event.complete('success');
    });

    const canMakePayment = await paymentRequest.canMakePayment();
    if (canMakePayment) {
      this.setState({ canMakePayment: true, hasCheckedAvailability: true });
    } else {
      this.setState({ canMakePayment: false, hasCheckedAvailability: true });
    }
  }

  render() {
    if (this.state.canMakePayment && this.state.paymentRequest) {
      return (
        <div>
          <form>
            <PaymentRequestButtonElement options={ { ...PaymentRequestButton.styleOptions, paymentRequest: this.state.paymentRequest } } />
          </form>
          <p className='center give-me-15-up-and-down'>or</p>
        </div>
      )
    } else return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/subscription/payment_request_button.jsx